import CONSTANT from './../../../../shared/constants/constant'
import VueElementLoading from 'vue-element-loading';
import axios from 'axios';
import { Validator } from 'vee-validate';
import RateTemplateView from './../../ratetemplate/ratetemplateview/index.vue';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable'
import MasterService from './../../../../masterdata/services/masterdata.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import ServiceView from './serviceview';
import Util from './../../../../shared/util/util';

export default {
  name: 'Template1',
  components: {
    CustomExpandableTable,
    VueElementLoading,
    RateTemplateView,
    CONSTANT,
    ServiceView
  },
  props: ['selectedEditRow', 'callingFromClientContractObj'],
  data() {
    return {
      countObj: {},
      disabled: true,
      lock: true,
      unlock: false,
      showTemplate: true,
      contractidd: '',
      parentmessage: '',
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Services'
        },
        {
          key: 'Second',
          value: 'Rates'
        },
        {
          key: 'Third',
          value: 'T&C'
        },
        {
          key: 'Fourth',
          value: 'Annexures'
        }
      ],
      tableColumn: ['Truck Load Type', 'Route Mode', 'Service Type', 'Booking Type', 'Effective Date From','Effective Date To' , 'Action'],
      tableItems: [],
      isLoading: false,
      tableItems: [],
      innerTableColumn: [],
      contractServiceList: [],
      AnnexureList: [],
      billingCycle: '',
			pod: '',
			date1: '',
			date2: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			advancePayment: '',
			creditAlert: '',
			paymentmode: '',
			liabilityAmount: '',
      isViewLoading:false,
			expanded:false,
      offset:0,
			accordianTab:{1:false, 2:false, 3:false}
    }
  },
  created: function() {

  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1;
      return this.currentTab.toLowerCase()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.contractidd = (this.callingFromClientContract && this.callingFromClientContract.existingContractTemplateId) || (!this.callingFromClientContract && this.selectedEdit && this.selectedEdit.id);
    })
    this.createTables();
    this.getContractTCDetails();
    this.getContractAnnexureListing();
  },
  methods: {
    expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
      this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
    format_date(value) {
      if (value) {
        return Util.displayDateOnlyFormat(value);
      }
    },
    async createTables() {
      try {
        this.ratetemplatemasterid
        this.isLoading = true;
        let hasSeriveIds = []
        let result;
        let payload = {}
        this.contractServiceList = []
        this.tableItems = [];
        let tempContractServiceList
        if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          let payload1 = {
            offset: this.offset,
            limit: 999,
            contractid: this.selectedEditRow.id
          }
          let payload2 = {
            contractid: this.selectedEditRow.id
          }
          result = await Promise.all([ClientService.getClientContractMasterServicesDetails(payload1), MasterService.clientContractMasterRateDetails(payload2)])
          tempContractServiceList = result[0].data.data.rows;
        } else {
          payload.contractid = this.selectedEditRow.id
          result = await Promise.all([MasterService.getContractMasterServicesDetails(payload), MasterService.contractMasterRateDetails(payload)])
          tempContractServiceList = result[0].data.data;
        }
        // payload.contractid = this.selectedEditRow.id
        // result = await Promise.all([MasterService.getContractMasterServicesDetails(payload), MasterService.contractMasterRateDetails(payload)])
        let effectiveDate = []
        result[1].data.data.rows.forEach((el) => {
          if (el.contractservicesid) {
            hasSeriveIds.push(el.contractservicesid);
            effectiveDate.push({
              serviceId: el.contractservicesid,
              startDate: el.rateeffectivedatefrom,
              endDate: el.rateeffectivedateto,
              rateTemplateId: el.id
            })
          }
        })
        if (result[1].data.data.rows.length > 0) {
          this.ratetemplatemasterid = result[1].data.data.rows[0].id
        }
        let tempPreFilledServiceRateList = [];
        tempContractServiceList.forEach((el) => {
          if (hasSeriveIds.includes(el.id)) {
            tempPreFilledServiceRateList.push(el);
          } else {
            this.contractServiceList.push(el);
          }
        })
        this.tableItems = tempPreFilledServiceRateList.map((el) => {
          let tempArr = []
          el.bookingtype.forEach((item) => {
            let type = CONSTANT.BOOKING_MODE[item]
            tempArr.push(type)
          });
          return {
            'id': el.id,
            'Truck Load Type': el.truckloadtype,
            'Route Mode': el.routemode,
            'Service Type': el.servicetype,
            'Booking Type': tempArr.join(", "),
            'Effective Date From': this.format_date(effectiveDate.find(o => o.serviceId == el.id).startDate),
            'Effective Date To': this.format_date(effectiveDate.find(o => o.serviceId == el.id).endDate),
            'rateTemplateId': effectiveDate.find(o => o.serviceId == el.id).rateTemplateId
          }
        })
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err)
      }
    },
    async getContractTCDetails() {
			let input = {
        contractid: this.selectedEditRow.id
      };
      let result;
      if(this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE){
        result = await ClientService.checkClientTermsConditionDetails(input);
      }else{
        result = await MasterService.getContractTermsCondition(input);
      }
			var data = result.data.data[0];
      if(data && data.id){
  			if(data.podhardcopyrequired==1){
  				this.pod = "Yes";
  			}else if(data.podhardcopyrequired==0){
  				this.pod = "No";
  			}
  			this.podCharge = data.podhardcopycharges;
  			if(data.billingcycle == 1){
  				this.billingCycle = "Monthly";
  				this.date1 = data.billsubmissionlastdate.cycle1;
  				this.date2 = '';
  			}else if(data.billingcycle == 2){
  				this.billingCycle = "Fortnightly";
  				this.date1 = data.billsubmissionlastdate.cycle1;
  				this.date2 = data.billsubmissionlastdate.cycle2;
  			}else if(data.billingcycle == 3){
  				this.billingCycle = "Weekly";
  			}
  			this.creditPeriod = data.creditperioddays;
  			this.creditLimit = data.creditlimit;
  			this.advancePayment = data.ftladvancepayment;
  			this.creditAlert = data.creditlimitalert;
  			let tempArr = [];
  			if(data.paymentmode.includes("1")){
  				tempArr.push("Cheque");
  			}
  			if(data.paymentmode.includes("2")){
  				tempArr.push("Demand Draft");
  			}
  			if(data.paymentmode.includes("3")){
  				tempArr.push("RTGS");
  			}
        if(tempArr.length >0){
          this.paymentmode = tempArr.join(", ");
        }
  			this.liabilityAmount = data.maxliability;
      }
		},
    async getContractAnnexureListing(){
      try {
        let inputPayload = {
          "offset": 0,
          "limit": 100
        }
        let result;
        if(this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE){
          inputPayload.clientcontractid = this.selectedEditRow.id;
          result = await ClientService.getClientAnnexureList(inputPayload);
        }else{
          inputPayload.contractid = this.selectedEditRow.id;
          result = await MasterService.getContractAnnexureListing(inputPayload);
        }
        this.AnnexureList = result.data.data.rows;
      } catch(err){
        console.log(err);
      }
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
    getCustomTableEvent(event) {
      if (event.actionType == "view") {
        let selectedServiceEditRow = this.tableItems.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedEditRow.serviceid = selectedServiceEditRow[0].id
        this.selectedEditRow.ratetemplateid = selectedServiceEditRow[0].rateTemplateId
        this.$nextTick(() => {
          this.$refs.childRateViewComponentFromListing && this.$refs.childRateViewComponentFromListing.setValues(this.selectedEditRow);
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/contracttemplate/contracttemplateview/contracttemplateview.component.js